// Ελληνικό περιεχόμενο για τα Efi's Apartments. Ίδια δομή με το site.en.js.
const A = "https://cdn.prod.website-files.com/69a710bf5700ed57fd4fffa2/";
const C = "/assets/comfort/";
const D = "/assets/onebed/";
const E = "/assets/petra/";

export { galleryImages } from "./site.en";

export const site = {
  name: "Efi's Apartments",
  tagline: "Μια συλλογή διαμερισμάτων μέσα σε πέτρινο αρχοντικό του 18ου αιώνα",
  bookingUrl: "https://efisapartmentsmilos.reserve-online.net/",
  phone: "+30 215 215 9912",
  phoneHref: "tel:+302152159912",
  whatsapp: "+30 697 998 3660",
  whatsappHref: "https://wa.me/306979983660",
  email: "contact@efismilos.com",
  emailHref: "mailto:contact@efismilos.com",
  address: "Πλάκα 848 00, Μήλος, Ελλάδα",
  mapsLink: "https://maps.app.goo.gl/4uhdGTvBKPPT2MhT7",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4506.011554753396!2d24.42524666063349!3d36.73770161083026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1498d8cb1c303701%3A0x54c01354aaf37e98!2sEfi's%20Apartments!5e1!3m2!1sen!2sus!4v1781869736648!5m2!1sen!2sus",
  elfsightId: "elfsight-app-86c15464-a98e-490a-a3fa-1f87f3d273fa",
  logo: "/assets/efis-logo-dark.png",
  logoWhite: "/assets/efis-logo-white.png",
  logoColor: "/assets/efis-logo-color.png",
  credit: { label: "Pharos Growth", url: "https://pharosgrowth.com" },
  mhte: {
    number: "ΜΗΤΕ: 1172K122K0660500",
    numberIcon: "/assets/mhte-emblem.png",
    managedPrefix: "Διαχείριση από",
    managedName: "Hotel Operation",
    managedUrl: "https://hoteloperation.com",
  },
};

export const nav = [
  { label: "Αρχική", to: "/" },
  { label: "Η Ιστορία του Σπιτιού", to: "/about" },
  { label: "Φωτογραφίες", to: "/gallery" },
  { label: "Ανακαλύψτε τη Μήλο", to: "/discover-milos" },
  { label: "Ταξιδιωτικοί Οδηγοί Μήλου", to: "/guides" },
  { label: "Επικοινωνία", to: "/contact" },
];

export const home = {
  heroImage: "/assets/efis-hero.jpg",
  heroTitle: "Τα Παλαιότερα Τείχη της Τρυπητής, η Καλύτερη Θέα της Μήλου",
  heroSubtitle: "Μια συλλογή διαμερισμάτων μέσα σε πέτρινο αρχοντικό του 18ου αιώνα",
  intro:
    "Ένα πέτρινο σπίτι του 18ου αιώνα στην Τρυπητή, αναστηλωμένο και ζωντανό, με θέα από τη βεράντα προς το Αιγαίο που δίνει τον τόνο σε όλα.",
  introImages: [
    A + "69e3b6315ccbc4aefa9c4485_Rectangle%204%20(1).avif",
    A + "69eb4a3c98a5db4bbe24b529_Rectangle%20204%20(1).avif",
  ],
  features: [
    {
      title: "Θέα στο Αιγαίο",
      text: "Δύσκολα θα κλείσετε τα παντζούρια.",
      image: A + "6a1c7546c4c72358e56b56be_place%201.svg",
    },
    {
      title: "Ένα Σπίτι, όχι Ξενοδοχείο",
      text: "Κάθε γωνιά κουβαλά την ιστορία της οικογένειας που το έχτισε.",
      image: A + "6a1c7d17ce7c60654d6a6bb7_Place%202%20(1).jpg",
    },
    {
      title: "Η Μήλος του Άλλοτε",
      text: "Όχι η Μήλος των καρτ-ποστάλ. Εκείνη που υπήρχε εδώ πριν από όλα.",
      image: A + "6a1c754650966f1b31e237b7_place%203.svg",
    },
  ],
  ownerQuote:
    "Ήρθα στη Μήλο ως επισκέπτρια. Η Τρυπητή με κράτησε, και αυτό το σπίτι είναι ο τρόπος μου να μοιραστώ το γιατί.",
  ownerBg: "/assets/owners-bg.jpg",
  ownerImages: [
    "/assets/sarakiniko-milos.jpg",
    "/assets/klima-sunset-milos.jpg",
    "/assets/kleftiko-milos.jpg",
    "/assets/firopotamos-village-milos.jpg",
    "/assets/sunset-hero-milos.jpg",
    "/assets/plaka-village-milos.jpg",
  ],
  exploreTitle: "Το Νησί Είναι Δικό Σας να το Εξερευνήσετε",
  exploreText:
    "Πλάκα, Κλήμα, Σαρακήνικο, Φυροπόταμος — η Μήλος ανταμείβει τους περίεργους, και η Τρυπητή σάς τοποθετεί ακριβώς στο κέντρο της.",
  exploreMap: "/assets/explore-map-milos.png",
  guidesTitle: "Η Μήλος που Δεν Θα Βρίσκατε Μόνοι",
  guidesText:
    "Η εμπειρία της Έφης από το 1995: οι παραλίες που αξίζουν τη διαδρομή, οι ταβέρνες που αξίζουν την αναμονή, και όλα όσα βρίσκονται ανάμεσα.",
};

export const about = {
  heroTitle: "Αυτό το Σπίτι Βρίσκεται Εδώ Πολύ Καιρό",
  intro:
    "Ένα πέτρινο σπίτι του 18ου αιώνα στην Τρυπητή, αναστηλωμένο και ζωντανό, με θέα από τη βεράντα προς το Αιγαίο που δίνει τον τόνο σε όλα.",
  values: [
    {
      title: "Αυθεντικότητα",
      text: "Τίποτα εδώ δεν σχεδιάστηκε για να μοιάζει με τη Μήλο. Απλώς είναι.",
      image: A + "6a1c7d17ce7c60654d6a6bb7_Place%202%20(1).jpg",
    },
    {
      title: "Τοπική Γνώση",
      text: "Η Έφη ξέρει ποια παραλία ταιριάζει σε ποιον άνεμο, ποια ταβέρνα δεν έχει μενού, και ποια μονοπάτια αξίζουν.",
      image: A + "6a102afca058e5242345eaed_Rectangle%20172%20(2).png",
    },
    {
      title: "Ησυχία εκ Σχεδιασμού",
      text: "Χωρίς pool bar, χωρίς οργανωμένες εκδρομές, χωρίς φασαρία. Μόνο το νησί, στον δικό του ρυθμό.",
      image: A + "6a1c81436d4d91ecdbf00ebb_Quiet%20by%20Design%20(1).jpg",
    },
    {
      title: "Χτισμένο απ' αυτόν τον Τόπο",
      text: "Πέτρινοι τοίχοι, γαλάζια παντζούρια, και μια αίσθηση του ανήκειν εδώ από το 1995.",
      image: A + "6a1c7ea48def5a8ce08c98f7_Contact%20Bg%20(1).jpg",
    },
  ],
  milestone: {
    year: "18ος αι.",
    title: "Χτίζεται το Σπίτι",
    text:
      "Μια οικογένεια χτίζει το σπίτι της στην Τρυπητή από την ηφαιστειακή πέτρα της πλαγιάς. Ο φούρνος, η στέρνα, ο κήπος, το μικρό μαγαζί — κάθε γωνιά εξυπηρετεί έναν σκοπό. Είναι ένα σπίτι που δουλεύει, κατοικημένο ολοκληρωτικά.",
    image: A + "69dec88b4c215e9d256412f6_Rectangle%20157.webp",
  },
  ownerQuote:
    "Ήρθα στη Μήλο ως επισκέπτρια. Η Τρυπητή με κράτησε, και αυτό το σπίτι είναι ο τρόπος μου να μοιραστώ το γιατί.",
  ownerName: "Έφη, Ιδιοκτήτρια",
  ownerImages: [
    A + "69e1f9255bd58b90b96be973_Rectangle%20176.webp",
    A + "6a1ab78e0e4017306fc59db0_Rectangle%20181.png",
  ],
};

export const apartments = [
  {
    slug: "petra-split-level-apartment",
    number: "01",
    name: "Διαμέρισμα Πέτρα (Split-Level)",
    short:
      "Ένα πέτρινο διαμέρισμα σε δύο επίπεδα με ιδιωτικό μπαλκόνι, ξεχωριστό υπνοδωμάτιο σε σοφίτα, απλά εξοπλισμένη κουζίνα και ηχομονωμένους τοίχους που κρατούν το χωριό ήσυχο.",
    tagline: "Μια Σοφίτα Πάνω, ένας Χώρος Ζωής Κάτω",
    long: [
      "Χτισμένο σε δύο επίπεδα με ντόπιο ξύλο και ηφαιστειακή πέτρα, κρατά τον ίδιο χαρακτήρα με το υπόλοιπο ακίνητο, αλλά με μια διαρρύθμιση που μοιάζει απόλυτα δική του.",
      "Κάτω, ένας ενιαίος χώρος καθιστικού με απλά εξοπλισμένη κουζίνα και τραπέζι. Πάνω, ένα διπλό κρεβάτι κρυμμένο στη σοφίτα — ένας χώρος ύπνου που νιώθεις πραγματικά ιδιωτικό κι όχι απλώς χωρισμένο. Το μπάνιο είναι σύγχρονο, οι τοίχοι ηχομονωμένοι, και ένα ιδιωτικό μπαλκόνι βλέπει στο ήσυχο, λιθόστρωτο σοκάκι από κάτω.",
    ],
    guests: "2 Άτομα",
    size: "30τ.μ.",
    beds: "1 Διπλό κρεβάτι (160×200 εκ.) + Καναπές-κρεβάτι",
    bedShort: "1 Διπλό κρεβάτι",
    bath: "1 Μπάνιο",
    card: E + "petra-03.jpg",
    hero: E + "petra-03.jpg",
    feature: E + "petra-15.jpg",
    gallery: [
      E + "petra-15.jpg",
      E + "petra-11.jpg",
      E + "petra-01.jpg",
      E + "petra-12.jpg",
      E + "petra-03.jpg",
      E + "petra-16.jpg",
      E + "petra-06.jpg",
      E + "petra-13.jpg",
      E + "petra-04.jpg",
      E + "petra-17.jpg",
      E + "petra-14.jpg",
      E + "petra-02.jpg",
    ],
    heritage: {
      intro:
        "Το Πέτρα είναι ένα γοητευτικό, εντελώς ανεξάρτητο σπιτάκι μέσα στο ακίνητο — πιστά αναστηλωμένο ώστε να διατηρεί την παραδοσιακή κυκλαδίτικη αρχιτεκτονική του. Φυσικές ηφαιστειακές πέτρες και μοναδικές λεπτομέρειες παντού ξυπνούν μια βαθιά αίσθηση αρχαίας ιστορίας.",
      features: [
        {
          term: "Μια Ζωντανή Μικρογραφία της Μήλου",
          greek: "Ταβλωτό · Στρωματσάδα",
          text: "Η διαρρύθμιση καθρεφτίζει ένα παραδοσιακό, ιστορικό σπίτι της Μήλου. Ο πάνω χώρος ύπνου — το ταβλωτό — αποτυπώνει τη ζωή του 18ου αιώνα, όταν όλη η οικογένεια ζούσε και κοιμόταν μαζί σε ένα μεγάλο στρώμα στον επάνω όροφο, ένα έθιμο γνωστό ως στρωματσάδα. Από κάτω βρίσκονται το ζεστό καθιστικό, ο χώρος της κουζίνας και το μπάνιο.",
          image: E + "petra-09.jpg",
        },
        {
          term: "Μια Βεράντα στη Σκιά",
          greek: "Ιδιωτικός εξωτερικός χώρος",
          text: "Το Πέτρα ανοίγει στη δική του ιδιωτική βεράντα — φτιαγμένη για τον πρωινό καφέ και ένα βραδινό ποτήρι κρασί — που μένει σε υπέροχη φυσική σκιά μέχρι περίπου τις 11:00–12:00 το μεσημέρι.",
          image: E + "petra-04.jpg",
        },
      ],
    },
  },
  {
    slug: "comfort-studio-with-garden-view",
    number: "02",
    name: "Studio Comfort με Θέα στον Κήπο",
    short:
      "Ένα άνετο, απλά εξοπλισμένο studio που ανοίγει σε έναν κοινόχρηστο, γαλήνιο κήπο και μια κοινόχρηστη ταράτσα. Απλό, άνετο, και ακριβώς όπως πρέπει να είναι μια καλή βάση σε ελληνικό νησί.",
    tagline: "Η Πλευρά του Σπιτιού προς τον Κήπο",
    long: [
      "Ένα καλοφτιαγμένο studio που το νιώθεις δικό σου από τη στιγμή που φτάνεις. Η διαρρύθμιση σε δύο επίπεδα του δίνει περισσότερο χαρακτήρα από ένα τυπικό studio, ενώ η κοινόχρηστη ταράτσα και ο κήπος είναι ένα πραγματικά υπέροχο σημείο για ένα χαλαρό πρωινό ή ένα ήσυχο βράδυ.",
    ],
    guests: "2 Άτομα",
    size: "25τ.μ.",
    beds: "1 Ημίδιπλο κρεβάτι (140×200 εκ.)",
    bedShort: "1 Ημίδιπλο κρεβάτι",
    bath: "1 Μπάνιο",
    card: C + "comfort-16.jpg",
    hero: C + "comfort-16.jpg",
    feature: C + "comfort-06.jpg",
    gallery: [
      C + "comfort-16.jpg",
      C + "comfort-06.jpg",
      C + "comfort-11.jpg",
      C + "comfort-13.jpg",
      C + "comfort-05.jpg",
      C + "comfort-07.jpg",
      C + "comfort-10.jpg",
      C + "comfort-08.jpg",
      C + "comfort-12.jpg",
      C + "comfort-15.jpg",
      C + "comfort-04.jpg",
      C + "comfort-14.jpg",
      C + "comfort-09.jpg",
      C + "comfort-01.jpg",
      C + "comfort-02.jpg",
      C + "comfort-03.jpg",
    ],
    heritage: {
      intro:
        "Δύο ισόγεια studios, όμορφα αναστηλωμένα και ξαναζωντανεμένα, στεφανωμένα με παραδοσιακά ταβάνια από αυθεντικές, πραγματικές ξύλινες τάβλες.",
      features: [
        {
          term: "Ταβάνια από Αληθινό Ξύλο",
          greek: "Τάβλες",
          text: "Κάθε studio είναι φτιαγμένο με παραδοσιακά ταβάνια από αυθεντικές, πραγματικές ξύλινες σανίδες, γνωστές ως τάβλες.",
          image: C + "comfort-14.jpg",
        },
        {
          term: "Ένας Κήπος από Ηφαιστειακό Βράχο",
          greek: "Κοινόχρηστος κήπος · ιδιωτικές γωνιές",
          text: "Ανοίγετε την πόρτα σας κατευθείαν σε έναν καταπράσινο κήπο στρωμένο με αρχαίο ηφαιστειακό βράχο — μια πέργκολα, λεμονιές, τριανταφυλλιές και ψηλά δέντρα που χαρίζουν δροσερή σκιά όλο το καλοκαίρι. Κάθε studio κρατά τη δική του μικρή, ιδιωτική πέτρινη γωνιά.",
        },
        {
          term: "Studio 1 — Ο Πέτρινος Φούρνος",
          greek: "Διατηρημένος φούρνος",
          text: "Ένας αυθεντικός, διατηρημένος παλιός πέτρινος φούρνος βρίσκεται μέσα στο μπάνιο — ένα κομμάτι καθημερινής ιστορίας, φυλαγμένο ακριβώς εκεί που πάντα στεκόταν.",
          image: C + "comfort-11.jpg",
        },
        {
          term: "Studio 1 — Γούρνα & Στέρνα",
          greek: "Γούρνα · Δεξαμενή",
          text: "Δίπλα σε ένα μικρό παράθυρο, μια παραδοσιακή γούρνα — μια πέτρινη λεκάνη όπου άλλοτε οι οικογένειες έβαζαν τη στάχτη από τον ξυλόφουρνο για να πλένουν ρούχα. Ακριβώς από κάτω βρίσκεται η δεξαμενή, η ιστορική στέρνα που μάζευε το βρόχινο νερό για πόσιμο, μπάνιο και πλύσιμο.",
          image: C + "comfort-03.jpg",
        },
        {
          term: "Ταράτσα με Θέα 180°",
          greek: "Κοινόχρηστο πανόραμα",
          text: "Και τα δύο studios μοιράζονται μια ευρύχωρη κοινόχρηστη ταράτσα με εκπληκτική θέα 180 μοιρών στον Κόλπο της Μήλου, το Ερημόμηλος, τον Αδάμαντα και όλη τη δυτική πλευρά του νησιού.",
        },
      ],
    },
  },
  {
    slug: "1-bedroom-apartments-with-sea-view-terrace",
    number: "03",
    name: "Διαμέρισμα με 1 Υπνοδωμάτιο & Βεράντα με Θέα στη Θάλασσα",
    short:
      "Ξεχωριστό υπνοδωμάτιο, απλά εξοπλισμένη κουζίνα και μια βεράντα που βλέπει κατευθείαν στο Αιγαίο.",
    tagline: "Το Διαμέρισμα για το Οποίο Οι Επισκέπτες Επιστρέφουν",
    long: [
      "Το ξεχωριστό υπνοδωμάτιο είναι δροσερό και ήρεμο, η κουζίνα έχει ό,τι χρειάζεστε για να φάτε στο σπίτι όποτε θέλετε, και η ιδιωτική βεράντα βλέπει κατευθείαν στο Αιγαίο.",
      "Αυτή η βεράντα είναι ο λόγος να κλείσετε αυτό το διαμέρισμα. Πρωινός καφές, βραδινό κρασί, και η θάλασσα ν' αλλάζει χρώμα στο ενδιάμεσο — θα περάσετε εκεί έξω περισσότερη ώρα απ' όση σχεδιάζατε.",
    ],
    guests: "2 Άτομα",
    size: "45τ.μ.",
    beds: "1 Ημίδιπλο κρεβάτι (140×200 εκ.) + 2 Καναπέδες-κρεβάτια",
    bedShort: "1 Ημίδιπλο κρεβάτι",
    bath: "1 Μπάνιο",
    card: D + "onebed-09.jpg",
    hero: D + "onebed-09.jpg",
    feature: D + "onebed-07.jpg",
    gallery: [
      D + "onebed-09.jpg",
      D + "onebed-02.jpg",
      D + "onebed-10.jpg",
      D + "onebed-08.jpg",
      D + "onebed-01.jpg",
      D + "onebed-05.jpg",
      D + "onebed-13.jpg",
      D + "onebed-07.jpg",
      D + "onebed-12.jpg",
      D + "onebed-11.jpg",
      D + "onebed-03.jpg",
      D + "onebed-04.jpg",
    ],
    heritage: {
      intro:
        "Ένα εντυπωσιακό διαμέρισμα χτισμένο γύρω από δύο εξαιρετικά, διατηρημένα ιστορικά στοιχεία που κάνουν τη διαμονή εδώ πραγματικά μοναδική.",
      features: [
        {
          term: "Ένα Κρεβάτι Μέσα σε Πατητήρι",
          greek: "Πατητήρι",
          text: "Το κύριο κρεβάτι είναι χτισμένο μέσα σε ένα όμορφα διατηρημένο πατητήρι — το αυθεντικό πέτρινο πατητήρι όπου οι χωρικοί πατούσαν τα σταφύλια για κρασί αιώνες πριν — μεταμορφωμένο τώρα με φροντίδα σε ένα μοναδικό διπλό κρεβάτι.",
          image: D + "onebed-10.jpg",
        },
        {
          term: "Η Πέτρα της Μπουγάδας",
          greek: "Αφημένη τραχιά επίτηδες",
          text: "Μια αυθεντική, τραχιά πέτρα όπου οι πρόγονοι έτριβαν τα ρούχα με στάχτη από τον παλιό φούρνο — αφημένη σκόπιμα τραχιά, ακριβώς όπως ήταν όταν οι λεκέδες έβγαιναν στο χέρι αιώνες πριν.",
          image: D + "onebed-08.jpg",
        },
        {
          term: "Μια Ιδιωτική Βεράντα",
          greek: "Φυσικά σκιασμένη",
          text: "Μια υπέροχη ιδιωτική βεράντα με ξύλινο τραπέζι και αναπαυτικές καρέκλες — το ιδανικό σημείο για τον πρωινό καφέ ή το ηλιοβασίλεμα, φυσικά σκιασμένο μέχρι τις 11:00–12:00 το μεσημέρι.",
          image: D + "onebed-09.jpg",
        },
        {
          term: "Μια Σπάνια, Αποκλειστική Θέα",
          greek: "Δυτικός Κόλπος Μήλου",
          text: "Αντί για μια απλή θέα στο ανοιχτό Αιγαίο, η βεράντα βλέπει στον Δυτικό Κόλπο της Μήλου, την Τραμηθιά, την Παναγία Τουρλιανή, το Ερημόμηλος, τη Βάνι, το Κλήμα και τις Κατακόμβες της Μήλου. Με πανσέληνο η θάλασσα γίνεται τόσο ήρεμη που θυμίζει γυάλινη λίμνη. Και για το ηλιοβασίλεμα και για την πανσέληνο, αυτή η βεράντα είναι ο λόγος να κλείσετε.",
          image: D + "onebed-02.jpg",
        },
      ],
    },
  },
];

export const heritage = {
  eyebrow: "Ζωντανή Κληρονομιά",
  title: "Αναστηλωμένο το 1995.",
  titleAccent: "Ανέγγιχτο από τον χρόνο.",
  intro:
    "Μέσα σε ένα αυθεντικό ακίνητο του 18ου αιώνα, τα διαμερίσματά μας αναστηλώθηκαν σχολαστικά το 1995 — ξαναχτίστηκαν από την αρχή για να δώσουν νέα πνοή στους ιστορικούς τους τοίχους. Βρίσκονται στην Τρυπητή, έναν οικισμό που το Ελληνικό Κράτος προστατεύει ως Παραδοσιακό Κυκλαδίτικο Αρχιτεκτονικό Οικισμό. Η αρχιτεκτονική του δεν επιτρέπεται να αλλοιωθεί: κάθε τοίχος και κάθε πέτρα μένει ανέγγιχτη από τον χρόνο, πιστή στο αυθεντικό κυκλαδίτικο ύφος.",
  stats: [
    { value: "18ος αι.", label: "Αρχικό ακίνητο" },
    { value: "1995", label: "Πιστή αναστήλωση" },
    { value: "οικισμός", label: "Προστατευόμενος τόπος" },
  ],
  milestones: [
    { year: "18ος αι.", title: "Χτισμένο από ηφαιστειακή πέτρα", icon: "Mountain" },
    { year: "Προστατευόμενος", title: "Αναγνωρισμένος κυκλαδίτικος οικισμός", icon: "Landmark" },
    { year: "1995", title: "Αναστηλωμένο από την αρχή", icon: "Hammer" },
    { year: "Σήμερα", title: "Δικό σας να το ζήσετε — ανέγγιχτο από τον χρόνο", icon: "Home" },
  ],
  pageTitle: "Ένα Σπίτι Ανέγγιχτο από τον Χρόνο",
  glance: [
    { icon: "MapPin", title: "Στην κορυφή του λόφου, στην Τρυπητή", text: "Λίγα βήματα από την Πλάκα, τις Κατακόμβες της Μήλου και το πιο ξακουστό ηλιοβασίλεμα του νησιού." },
    { icon: "Home", title: "Λίγα, ξεχωριστά διαμερίσματα", text: "Το καθένα με τον δικό του χαρακτήρα, διαρρύθμιση και εξωτερικό χώρο — καμία διαμονή δεν μοιάζει με την άλλη." },
    { icon: "Waves", title: "Πανοραμική θέα στο Αιγαίο", text: "Απλόχωρη θέα στον Δυτικό Κόλπο της Μήλου και το ανοιχτό πέλαγος, μέρα και με το φως του φεγγαριού." },
    { icon: "Users", title: "Ένα ζεστό, τοπικό καλωσόρισμα", text: "Σας φροντίζει η οικογένεια που αναστήλωσε το σπίτι και έχει το χωριό αυτό για σπίτι της." },
  ],
  pageIntro:
    "Ένα αυθεντικό πέτρινο σπίτι του 18ου αιώνα στην Τρυπητή — πιστά αναστηλωμένο το 1995 και προστατευμένο, διά νόμου, ακριβώς όπως χτίστηκε.",
  story: [
    {
      title: "Ένα Ακίνητο του 18ου Αιώνα",
      text: "Μέσα σε ένα αυθεντικό ακίνητο του 18ου αιώνα, τα διαμερίσματά μας αναστηλώθηκαν σχολαστικά το 1995 — δίνοντας νέα πνοή στους ιστορικούς τους τοίχους, διατηρώντας ανέπαφο τον αρχικό τους χαρακτήρα.",
    },
    {
      title: "Προστατευόμενο από το Κράτος",
      text: "Η Τρυπητή αναγνωρίζεται επίσημα από το Ελληνικό Κράτος ως Παραδοσιακός Κυκλαδίτικος Οικισμός. Η αρχιτεκτονική της δεν επιτρέπεται να αλλοιωθεί — έτσι το ακίνητο διατηρείται ακριβώς στο αυθεντικό, διαχρονικό κυκλαδίτικο ύφος του.",
    },
    {
      title: "Κοινός Κήπος & Κοινότητα",
      text: "Όλα τα διαμερίσματα μοιράζονται έναν όμορφο κοινό κήπο και μια κοινόχρηστη ταράτσα — καλλιεργώντας μια ζεστή, φιλόξενη αίσθηση κοινότητας, που θυμίζει όμορφα το πώς άκμαζε η ζωή της γειτονιάς τον 18ο αιώνα.",
    },
    {
      title: "Ιστορική Πετροδομή",
      text: "Οι αυθεντικές πέτρες σε όλα τα διαμερίσματα σχηματίζουν έναν ιστορικό τοίχο από ηφαιστειακή πέτρα, που έχει διατηρηθεί εδώ με ασφάλεια επί αιώνες και ακόμη κρατά το σπίτι.",
    },
    {
      title: "Μια Σημείωση για τις Κουζίνες",
      text: "Οι κουζίνες μας είναι απλά εξοπλισμένες με ό,τι χρειάζεστε για να ετοιμάσετε ένα ωραίο πρωινό και ελαφριά σνακ.",
    },
  ],
  points: [
    {
      icon: "Landmark",
      title: "Προστατευόμενη Κυκλαδίτικη Κληρονομιά",
      text: "Η Τρυπητή αναγνωρίζεται επίσημα από το Ελληνικό Κράτος ως Παραδοσιακός Κυκλαδίτικος Αρχιτεκτονικός Οικισμός. Η αρχιτεκτονική δεν επιτρέπεται να αλλοιωθεί — έτσι το ακίνητο στέκει ακριβώς όπως χτίστηκε.",
    },
    {
      icon: "Coffee",
      title: "Φτιαγμένο για Χαλαρά Πρωινά",
      text: "Οι κουζίνες μας είναι απλά εξοπλισμένες — η καθεμία με ό,τι χρειάζεστε για ένα ωραίο πρωινό και ελαφριά σνακ.",
    },
    {
      icon: "Trees",
      title: "Κοινός Κήπος & Ταράτσα",
      text: "Κάθε διαμέρισμα μοιράζεται έναν όμορφο κοινό κήπο και μια κοινόχρηστη ταράτσα — μια ζεστή αίσθηση κοινότητας, όπως άκμαζε εδώ η ζωή της γειτονιάς τον 18ο αιώνα.",
    },
    {
      icon: "Mountain",
      title: "Αιωνόβια Πετροδομή",
      text: "Οι αυθεντικές πέτρες παντού σχηματίζουν έναν ιστορικό τοίχο από ηφαιστειακή πέτρα, διατηρημένο με ασφάλεια επί αιώνες.",
    },
  ],
};

export const amenities = [
  { icon: "Snowflake", label: "Κλιματισμός" },
  { icon: "Wifi", label: "Δωρεάν Wi-Fi" },
  { icon: "CookingPot", label: "Εξοπλισμένη Κουζίνα" },
  { icon: "Flame", label: "Εστίες Μαγειρέματος" },
  { icon: "TreePalm", label: "Βεράντα / Μπαλκόνι" },
  { icon: "ShowerHead", label: "Σύγχρονο Μπάνιο" },
  { icon: "EarOff", label: "Ηχομονωμένοι Τοίχοι" },
  { icon: "Utensils", label: "Τραπέζι Φαγητού" },
  { icon: "Eye", label: "Θέα σε Θάλασσα / Κήπο" },
  { icon: "Thermometer", label: "Θέρμανση" },
  { icon: "BedDouble", label: "Καθαρά Λευκά Είδη & Πετσέτες" },
  { icon: "Coffee", label: "Καφές & Τσάι" },
];

export const houseRules = [
  {
    icon: "Clock",
    title: "Άφιξη & Αναχώρηση",
    text: "Η άφιξη (check-in) γίνεται από τις 3:00 μ.μ. έως τις 11:00 μ.μ., και η αναχώρηση (check-out) έως τις 11:00 π.μ. Η καθυστερημένη αναχώρηση υπόκειται σε διαθεσιμότητα.",
  },
  {
    icon: "CigaretteOff",
    title: "Απαγορεύεται το Κάπνισμα σε Εσωτερικούς Χώρους",
    text: "Το κάπνισμα δεν επιτρέπεται μέσα στο κατάλυμα. Οι επισκέπτες μπορούν να χρησιμοποιούν τους καθορισμένους εξωτερικούς χώρους.",
  },
  {
    icon: "Moon",
    title: "Ώρες Ησυχίας",
    text: "Για μια γαλήνια διαμονή για όλους τους επισκέπτες, τηρούνται ώρες ησυχίας από τις 10:00 μ.μ. έως τις 8:00 π.μ.",
  },
  { icon: "PartyPopper", title: "Πάρτι", text: "Δεν επιτρέπονται πάρτι / εκδηλώσεις." },
  { icon: "PawPrint", title: "Κατοικίδια", text: "Δεν επιτρέπονται κατοικίδια." },
];

export const discover = {
  heroTitle: "Ανακαλύψτε τη Μήλο",
  heroTagline: "Ένα ηφαιστειογενές νησί που ποτέ δεν αποφάσισε να γίνει συνηθισμένο.",
  heroImage: "/assets/discover-hero.webp",

  quote:
    "Η Μήλος δεν αποκαλύπτεται μονομιάς. Δώστε της λίγες αργές μέρες και γίνεται σιωπηλά το νησί με το οποίο συγκρίνετε κάθε άλλο.",
  quoteImage:
    "https://images.pexels.com/photos/14604430/pexels-photo-14604430.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",

  mapEyebrow: "Η Διαμόρφωση του Τόπου",
  mapTitle: "Ένα νησί, εκατό διαφορετικές μέρες",
  mapText:
    "Εβδομήντα παραλίες, αρχαίες κατακόμβες, ψαροχώρια με χρωματιστές πόρτες, και μια ακτογραμμή που φαίνεται διαφορετική κάθε φορά που αλλάζει το φως. Και το σπίτι μας βρίσκεται ακριβώς στο κέντρο της, στην Τρυπητή.",
  mapImage: A + "69d5aad67b012ab94c8de6ac_map-part.webp",
  mapBgImage:
    "https://images.unsplash.com/photo-1699020685614-57f4cc28306e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",

  ribbon: [
    "72 πανέμορφες παραλίες",
    "1 ηφαιστειακή καρδιά",
    "ατελείωτο αιγαιοπελαγίτικο μπλε",
    "κατακόμβες παλαιότερες από τους περισσότερους καθεδρικούς",
    "ηλιοβασιλέματα που αξίζει να σχεδιάσεις τη μέρα σου γύρω τους",
  ],

  poiEyebrow: "Γύρω από το Κατάλυμα",
  poiTitle: "Αξίζει ν' Αφήσετε τη Βεράντα",
  poiText:
    "Όλα εδώ είναι εύκολα προσβάσιμα από το σπίτι — τα περισσότερα με μια σύντομη διαδρομή, κάποια με τα πόδια. Αυτά είναι τα μέρη όπου στέλνουμε πρώτα τους δικούς μας επισκέπτες.",
  pois: [
    {
      name: "Μανδράκια",
      area: "Ψαροχώρι · 10 λεπτά",
      text: "Ένα μικροσκοπικό λιμανάκι με σύρματα — γκαράζ βαρκών βαμμένα σε γαλάζια και κόκκινα του πελάγους. Ελάτε για μεσημεριανό στην άκρη του νερού και σε μία από τις καλύτερες παραλίες του νησιού δίπλα.",
      image: "https://images.unsplash.com/photo-1700850139282-9e01d348bf65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "Αχιβαδολίμνη",
      area: "Κορυφαίες παραλίες · 15 λεπτά",
      text: "Η μεγαλύτερη αμμώδης παραλία του νησιού — ρηχή, ήρεμη και ανέμελη. Η εύκολη μέρα στην παραλία όταν θέλετε απλώς άμμο κάτω από τα πόδια σας.",
      image: "/assets/achivadolimni-beach-milos.jpg",
    },
    {
      name: "Ερημόμηλος",
      area: "Νησίδα του ηλιοβασιλέματος",
      text: "Η μικρή ακατοίκητη νησίδα στα δυτικά. Δείτε τον ήλιο να πέφτει πίσω της και όλος ο κόλπος γίνεται χάλκινος και τριανταφυλλής.",
      image: "/assets/erimomilos-milos.jpg",
    },
    {
      name: "Κλήμα",
      area: "Το πιο φωτογραφημένο χωριό",
      text: "Πολύχρωμα σπιτάκια για βάρκες χτισμένα πάνω στην ίσαλο γραμμή, να λάμπουν την ώρα της χρυσής ώρας. Η εικόνα της Μήλου που έχετε ήδη δει — καλύτερη από κοντά.",
      image: "https://images.unsplash.com/photo-1684246151131-af631e2d85bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "Βάνι",
      area: "Ιδίως για ηλιοβασίλεμα",
      text: "Ένα απομακρυσμένο, πρώην ορυχείο μαγγανίου, τώρα άγριος, σκουριασμένος-κόκκινος όρμος. Ένα από τα πιο υποτιμημένα μέρη του νησιού για να δεις τη μέρα να τελειώνει.",
      image: "/assets/vani-milos.jpg",
    },
    {
      name: "Παναγία Τουρλιανή",
      area: "Κλιματοβούνι · απέναντι από την Τρυπητή",
      text: "Η εκκλησία στην πλαγιά του Κλιματοβουνίου, ακριβώς απέναντι από την Τρυπητή — μια γαλήνια στάση με πλατιά, ήσυχη θέα στον κόλπο.",
      image: "/assets/poi-panagia-tourliani-milos.jpg",
    },
    {
      name: "Άγιος Νικόλαος, Τρυπητή",
      area: "Χτισμένος από το χωριό",
      text: "Η αγαπημένη εκκλησία της Τρυπητής, χτισμένη από τους ίδιους τους ντόπιους — με τα παιδιά του χωριού να κουβαλούν πέτρες για να βοηθήσουν στο χτίσιμό της.",
      image: "/assets/poi-agios-nikolaos-milos.jpg",
    },
    {
      name: "Το Αρχαίο Θέατρο",
      area: "Ρωμαϊκό μάρμαρο · πάνω από το Κλήμα",
      text: "Ένα μαρμάρινο ρωμαϊκό θέατρο σκαλισμένο στην πλαγιά, που ακόμη πλαισιώνει την ίδια θάλασσα όπως και πριν δύο χιλιάδες χρόνια.",
      image: "/assets/poi-ancient-theatre-milos.jpg",
    },
    {
      name: "Εκεί Όπου Βρέθηκε η Αφροδίτη",
      area: "Αφροδίτη της Μήλου · 1820",
      text: "Το ακριβές σημείο όπου ήρθε στο φως η Αφροδίτη της Μήλου το 1820 — λίγα βήματα από το θέατρο, σημαδεμένο και σιωπηλά συγκινητικό.",
      image: "https://images.unsplash.com/photo-1685062478366-907bf61feee0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "Οι Ανεμόμυλοι",
      area: "Ανεμόμυλοι · 5 λεπτά με τα πόδια",
      text: "Οι παλιοί ασβεστωμένοι ανεμόμυλοι που φρουρούν την Τρυπητή — μια σύντομη βόλτα, και το καλύτερο σημείο για να καλωσορίσετε το βράδυ.",
      image: "/assets/poi-windmills-milos.jpg",
    },
    {
      name: "Η Πλατεία της Τρυπητής",
      area: "Το χωριό μας",
      text: "Η δική μας πλατεία του χωριού: δυο ταβέρνες, ένα δέντρο για σκιά, και ο ανέμελος ρυθμός της νησιώτικης ζωής μπροστά σας.",
      image: "/assets/poi-trypiti-square-milos.jpg",
    },
    {
      name: "Οι Κατακόμβες",
      area: "Παλαιοχριστιανικές · μια ανάσα μακριά",
      text: "Οι μοναδικές παλαιοχριστιανικές κατακόμβες στην Ελλάδα — υπόγειες στοές σκαλισμένες στον βράχο, από τα πιο αξιοθαύμαστα μνημεία στο Αιγαίο.",
      image: "/assets/catacombs-milos.jpg",
    },
  ],

  gettingAroundTitle: "Μετακινήσεις στο Νησί",
  gettingAroundText:
    "Η Μήλος ανταμείβει την περιπλάνηση. Από την Τρυπητή είστε κεντρικά — και οι δύο ακτές είναι κοντά, και σχεδόν όλα σε αυτή τη λίστα απέχουν μια σύντομη, γραφική διαδρομή.",
  gettingAround: [
    { h: "Νοικιάστε αυτοκίνητο", p: "Την ελευθερία να κυνηγάτε όρμους και ηλιοβασιλέματα με το δικό σας πρόγραμμα. Χαρούμενα κανονίζουμε ένα για εσάς." },
    { h: "Παραλίες: 10–25 λεπτά", p: "Και οι δύο ακτές, βόρεια και νότια, είναι κοντά, ώστε να ακολουθείτε την ήρεμη πλευρά όταν φυσάει το μελτέμι." },
    { h: "Βάρκα για το Κλέφτικο", p: "Οι πειρατικές θαλασσοσπηλιές φτάνονται μόνο από τη θάλασσα — κλείστε μια μισής μέρας κρουαζιέρα από τον Αδάμαντα." },
  ],
  efiNote:
    "Η ειλικρινής μου συμβουλή: νοικιάστε αυτοκίνητο — είναι μακράν ο καλύτερος τρόπος να δείτε τη Μήλο. Εναλλακτικά, μπορείτε να νοικιάσετε μια γουρούνα ή ένα σκούτερ. Και μη βασίζεστε στο τοπικό λεωφορείο για να εξερευνήσετε το νησί· δεν φτάνει σε πολλές από τις καλύτερες γωνιές, και τα δρομολόγια δεν είναι αξιόπιστα. Με αυτοκίνητο, όλο το νησί ανοίγεται μπροστά σας.",

  efiEyebrow: "Η Μήλος της Έφης",
  efiTitle: "Αυτά που θα έλεγα σε έναν φίλο",
  efiText:
    "Μετά από χρόνια που καλωσορίζω επισκέπτες, άρχισα να γράφω τις απαντήσεις στις ερωτήσεις που πάντα μου κάνουν — πού να κολυμπήσετε, πού να δείτε τον ήλιο να δύει, ποια ταβέρνα αξίζει τη διαδρομή. Αυτοί οι οδηγοί είναι ακριβώς ό,τι θα έλεγα σε έναν φίλο που φτάνει στη Μήλο για πρώτη φορά. Τίποτα εδώ δεν είναι χορηγία. Είναι απλώς το νησί που αγαπώ, και οι γωνιές του που ελπίζω ν' αγαπήσετε κι εσείς.",
  efiSignature: "— Έφη, η οικοδέσποινά σας στην Τρυπητή",

  guidesEyebrow: "Οι Εκτενείς Οδηγοί",
  guidesTitle: "Η Μήλος, Ολόκληρη",
  guidesText: "Βολευτείτε. Αυτές είναι οι πιο εις βάθος αναλύσεις — παραλίες, χωριά, φαγητό, και τα σημεία που οι περισσότεροι προσπερνούν.",
};

export const policy = {
  title: "Πολιτική Απορρήτου",
  intro:
    "Τα Efi's Apartments είναι ένα μικρό, οικογενειακό μπουτίκ κατάλυμα στην Τρυπητή της Μήλου. Αυτή η πολιτική εξηγεί τα περιορισμένα προσωπικά δεδομένα που διαχειριζόμαστε όταν επισκέπτεστε αυτόν τον ιστότοπο ή επικοινωνείτε για να κανονίσετε μια διαμονή — και πώς τα κρατάμε ασφαλή. Συμμορφωνόμαστε με τον Γενικό Κανονισμό Προστασίας Δεδομένων της ΕΕ (GDPR).",
  sections: [
    {
      h: "Πώς Λειτουργεί Αυτός ο Ιστότοπος",
      p: [
        "Πρόκειται για έναν απλό ενημερωτικό ιστότοπο. Δεν υπάρχουν λογαριασμοί χρηστών, και δεν μπορείτε να πληρώσετε ή να ολοκληρώσετε κράτηση απευθείας εδώ. Όταν αποφασίσετε να κλείσετε, μεταφέρεστε στο εξωτερικό μας σύστημα κρατήσεων, το οποίο διαχειρίζεται τα στοιχεία της κράτησης και της πληρωμής σας υπό τους δικούς του όρους απορρήτου.",
      ],
    },
    {
      h: "Ποιες Πληροφορίες Συλλέγουμε",
      intro: "Συλλέγουμε μόνο όσα επιλέγετε να μοιραστείτε μαζί μας:",
      list: [
        "Στοιχεία επικοινωνίας — το όνομά σας, το email, το τηλέφωνο ή τον αριθμό WhatsApp, και το περιεχόμενο του μηνύματός σας — όταν μας στέλνετε email, τηλεφωνείτε ή μας γράφετε για μια διαμονή.",
        "Στοιχεία διαμονής — όπως οι ημερομηνίες σας και τυχόν ειδικά αιτήματα — όταν μας τα στέλνετε ώστε να προετοιμαστούμε για την επίσκεψή σας.",
        "Βασικά, ανώνυμα δεδομένα χρήσης που ενδέχεται να συλλέγονται από τα εργαλεία τρίτων που είναι ενσωματωμένα σε αυτόν τον ιστότοπο (δείτε παρακάτω).",
      ],
    },
    {
      h: "Πώς Χρησιμοποιούμε τις Πληροφορίες σας",
      intro: "Χρησιμοποιούμε τις πληροφορίες σας μόνο για να:",
      list: [
        "Απαντάμε στα ερωτήματά σας και να βοηθάμε στην οργάνωση της διαμονής σας.",
        "Σας στέλνουμε τις πρακτικές λεπτομέρειες που χρειάζεστε πριν και κατά τη διάρκεια της επίσκεψής σας, όπως οδηγίες πρόσβασης.",
        "Εκπληρώνουμε τις νομικές και λογιστικές μας υποχρεώσεις.",
      ],
    },
    {
      h: "Υπηρεσίες Τρίτων",
      intro:
        "Λίγες αξιόπιστες υπηρεσίες τρίτων είναι ενσωματωμένες σε αυτόν τον ιστότοπο ή χρησιμοποιούνται για τη λειτουργία της επιχείρησής μας. Η καθεμία έχει τη δική της πολιτική απορρήτου:",
      list: [
        "Το εξωτερικό μας σύστημα κρατήσεων, που επεξεργάζεται κρατήσεις και πληρωμές.",
        "Οι Χάρτες Google, που χρησιμοποιούνται για να δείξουν την τοποθεσία μας.",
        "Το Elfsight, που χρησιμοποιείται για την προβολή επαληθευμένων κριτικών επισκεπτών.",
      ],
    },
    {
      h: "Κοινοποίηση των Πληροφοριών σας",
      list: [
        "Δεν πουλάμε ούτε ενοικιάζουμε ποτέ τα προσωπικά σας δεδομένα.",
        "Μοιραζόμαστε πληροφορίες μόνο με τους παραπάνω παρόχους υπηρεσιών — αποκλειστικά για τη λειτουργία αυτού του ιστότοπου και την οργάνωση της διαμονής σας — ή όπου απαιτείται από τον νόμο.",
      ],
    },
    {
      h: "Διατήρηση & Ασφάλεια Δεδομένων",
      p: [
        "Κρατάμε τις πληροφορίες σας μόνο για όσο χρειάζεται ώστε να απαντήσουμε στο ερώτημά σας, να φιλοξενήσουμε τη διαμονή σας και να εκπληρώσουμε τις νομικές μας υποχρεώσεις, και λαμβάνουμε εύλογα μέτρα για να τις προστατεύσουμε από μη εξουσιοδοτημένη πρόσβαση ή κοινοποίηση.",
      ],
    },
    {
      h: "Τα Δικαιώματά σας",
      intro: "Βάσει του GDPR έχετε το δικαίωμα να:",
      list: [
        "Έχετε πρόσβαση στα προσωπικά δεδομένα που τηρούμε για εσάς.",
        "Μας ζητήσετε να τα διορθώσουμε ή να τα διαγράψουμε, με την επιφύλαξη τυχόν νομικών υποχρεώσεων.",
        "Αντιταχθείτε ή να περιορίσετε τη χρήση τους, και να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή.",
      ],
    },
    {
      h: "Cookies",
      p: [
        "Αυτός ο ιστότοπος δεν χρησιμοποιεί cookies για διαφήμιση. Ορισμένα ενσωματωμένα εργαλεία τρίτων (όπως οι Χάρτες Google ή το widget κριτικών) ενδέχεται να ορίζουν δικά τους cookies· μπορείτε να τα διαχειριστείτε μέσα από τις ρυθμίσεις του προγράμματος περιήγησής σας.",
      ],
    },
    {
      h: "Επικοινωνήστε μαζί μας",
      p: [
        "Για οποιαδήποτε ερώτηση σχετικά με αυτήν την πολιτική ή τα προσωπικά σας δεδομένα, στείλτε email στο contact@efismilos.com ή τηλεφωνήστε στο +30 215 215 9912. Efi's Apartments, Πλάκα 848 00, Μήλος, Ελλάδα.",
      ],
    },
  ],
};

export const bookingPolicy = {
  title: "Πολιτική Κρατήσεων",
  intro:
    "Προσφέρουμε δύο τύπους τιμών όταν κλείνετε τη διαμονή σας στα Efi's Apartments. Επιλέξτε αυτόν που σας ταιριάζει καλύτερα — οι όροι πληρωμής και ακύρωσης για τον καθένα παρατίθενται καθαρά παρακάτω.",
  rates: [
    {
      name: "Μη Επιστρέψιμη Τιμή",
      badge: "Καλύτερη τιμή",
      payment: ["Απαιτείται πλήρης πληρωμή κατά τη στιγμή της κράτησης."],
      cancellation: [
        "Δεν είναι διαθέσιμη η δωρεάν ακύρωση.",
        "Σε περίπτωση ακύρωσης, η χρέωση ακύρωσης είναι το 100% του συνολικού κόστους της διαμονής.",
        "Σε περίπτωση μη εμφάνισης (no-show), η χρέωση είναι ίδια με μια ακύρωση της τελευταίας στιγμής.",
      ],
    },
    {
      name: "Κανονική Τιμή",
      badge: "Πιο ευέλικτη",
      payment: [
        "Απαιτείται προκαταβολή ίση με μία διανυκτέρευση κατά τη στιγμή της κράτησης.",
        "Το υπόλοιπο ποσό εξοφλείται 7 ημέρες πριν την άφιξη.",
      ],
      cancellation: [
        "Δεν είναι διαθέσιμη η δωρεάν ακύρωση.",
        "Σε περίπτωση ακύρωσης, η χρέωση ακύρωσης είναι το κόστος μίας διανυκτέρευσης.",
        "Αν η κράτηση ακυρωθεί εντός 7 ημερών από την άφιξη, η χρέωση ακύρωσης είναι το 100% του συνολικού κόστους της διαμονής.",
        "Σε περίπτωση μη εμφάνισης (no-show), η χρέωση είναι ίδια με μια ακύρωση της τελευταίας στιγμής.",
      ],
    },
  ],
};
